import { render, staticRenderFns } from "./declinarModal.vue?vue&type=template&id=e2750f62&scoped=true"
import script from "./declinarModal.vue?vue&type=script&lang=js"
export * from "./declinarModal.vue?vue&type=script&lang=js"
import style0 from "./declinarModal.vue?vue&type=style&index=0&id=e2750f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2750f62",
  null
  
)

export default component.exports